import React from 'react';
import { Package } from 'lucide-react';
interface Plan {
  name: string;
  price: number;
}
interface PlanDropdownProps {
  value: string;
  onChange: (planName: string) => void;
}
const plans: Plan[] = [{
  name: 'Core',
  price: 997
}, {
  name: 'Scale',
  price: 1597
}];
/**
 * PlanDropdown component
 * Dropdown selector for AcquireFlow pricing plans
 */
export function PlanDropdown({
  value,
  onChange
}: PlanDropdownProps) {
  const selectedPlan = plans.find(p => p.name === value) || plans[0];
  return <div className="space-y-3" data-id="element-2051">
      {/* Label and Value */}
      <div className="flex items-center justify-between" data-id="element-2052">
        <div className="flex items-center gap-2" data-id="element-2053">
          <div className="text-[#3ab795]" data-id="element-2054">
            <Package className="w-4 h-4" data-id="element-2055" />
          </div>
          <label className="text-base font-medium text-white/90" data-id="element-2056">
            AcquireFlow Plan
          </label>
        </div>
        <div className="flex items-baseline gap-1" data-id="element-2057">
          <span className="text-3xl font-bold text-[#3ab795]" data-id="element-2058">
            ${selectedPlan.price}
          </span>
          <span className="text-sm text-[#b8bcc8]" data-id="element-2059">/mo</span>
        </div>
      </div>

      {/* Dropdown */}
      <div className="relative" data-id="element-2060">
        <select value={value} onChange={e => onChange(e.target.value)} className="w-full px-4 py-3 bg-white/5 border border-white/10 rounded-lg text-white appearance-none cursor-pointer hover:border-[#3ab795]/40 focus:border-[#3ab795] focus:outline-none focus:ring-2 focus:ring-[#3ab795]/20 transition-all" data-id="element-2061">
          {plans.map(plan => <option key={plan.name} value={plan.name} className="bg-[#1a1a1a] text-white" data-id="element-2062">
              {plan.name} - ${plan.price}/month
            </option>)}
        </select>

        {/* Dropdown Arrow */}
        <div className="absolute right-4 top-1/2 -translate-y-1/2 pointer-events-none" data-id="element-2063">
          <svg className="w-4 h-4 text-[#3ab795]" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-2064">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" data-id="element-2065" />
          </svg>
        </div>
      </div>

      {/* Plan Description */}
      <div className="text-sm text-[#b8bcc8] leading-relaxed" data-id="element-2066">
        {value === 'Core' && 'Full automation + advanced features for serious investors'}
        {value === 'Scale' && 'Maximum volume + priority support + dedicated account manager'}
      </div>
    </div>;
}
export const PLANS = plans;